import ReusableTable from './ReusableTable';

export default ReusableTable;
